import React, { useEffect, useState } from "react";
import { Alert, Nav, Navbar, NavItem, Row, TabContainer, TabContent, TabPane } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { candidateId as candidateIdAtom } from "../../recoil/candidate/atom";
import { loadAppliedApplications } from "../../requests/applicationApplied";
import { loadDraftApplications } from "../../requests/applicationDrafts";
import { patchApplication } from "../../requests/applications";
import { getCurrentCandidateDocumentStatus } from "../../requests/candidates";
import { modalState } from "../../recoil/modal/atom";
import { toastMessageState } from "../../recoil/toast/atom";
import styles from "./ApplicationList.module.scss";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import AppliedApplicationList from "../../components/List/AppliedApplicationList";
import DraftApplicationList from "../../components/List/DraftApplicationList";
import WithdrawForm from "../../components/Form/WithdrawForm/WithdrawForm";
import { Loading } from "qjumpers.common.ui";
const ApplicationList = (props) => {
  const { t } = useTranslation();
  const candidateId = useRecoilValue(candidateIdAtom);
  const popModal = useSetRecoilState(modalState);
  const popToast = useSetRecoilState(toastMessageState);
  const routeParams = useParams();
  const history = useHistory();
  const type = routeParams.type;
  const params = props.params;
  const [initCalled, setinitCalled] = useState(false);
  const [showAlert, setShowAlert] = useState("");
  const [currentState, setCurrentState] = useState(type && type !== "" ? type : "applied");
  const [draftListSummaryObject, setDraftListSummaryObject] = useState({
    totalPages: 0,
    totalElements: 0,
    content: [],
    number: parseInt(params?.page) > 1 ? params?.page - 1 : 0,
    size: parseInt(params?.size) > 0 ? params?.size : 10,
  });
  const [appliedListSummaryObject, setAppliedListSummaryObject] = useState({
    totalPages: 0,
    totalElements: 0,
    content: [],
    number: parseInt(params?.page) > 1 ? params?.page - 1 : 0,
    size: parseInt(params?.size) > 0 ? params?.size : 10,
  });

  const loadData = (pageNumber) => {
    if (draftListSummaryObject.totalElements === 0) {
      loadDraftApplications(pageNumber ? pageNumber : draftListSummaryObject.number, draftListSummaryObject.size).then((result) => {
        if (result.data) {
          setDraftListSummaryObject(result.data);
        } else {
          popToast([]);
        }
      });
    }

    if (appliedListSummaryObject.totalElements === 0) {
      loadAppliedApplications(pageNumber ? pageNumber : appliedListSummaryObject.number, appliedListSummaryObject.size).then((result) => {
        if (result.data) {
          setAppliedListSummaryObject(result.data);
        } else {
          popToast([]);
        }
        setinitCalled(true);
      });
    }
  }

  useEffect(() => {
    getCurrentCandidateDocumentStatus().then((result) => {
      if (result.data) {
        setShowAlert(result.data);
      }
    })
    .catch((error) => {
      console.log("DocumentStatus error", error);
    });

    if (candidateId != null) {
        loadData();
      }
    }, [candidateId]);

  const onPageChanged = (page) => {
    let newListSummaryObject = currentState === "drafts" ? draftListSummaryObject : appliedListSummaryObject;

    if (page > 0 && page <= newListSummaryObject.totalPages) {
      history.push("/applications/" + page);
      newListSummaryObject.number = page - 1;
      loadData(newListSummaryObject.number);
    }
  };

  const handleStateChange = currentStateInput => {
    setCurrentState(currentStateInput);
    loadData();
  };

  const clearModal = () => {
    popModal([]);
  }

  const handleSubmitWithdraw = (application) => {
    popModal([{
      title:t("Application.Withdraw.Modal"),
      show: true,
      children: (
        <div>
          <WithdrawForm initialValues={{ id: application.applicationId }} onSubmit={doSubmitWithdraw} onCancel={clearModal} />
        </div>
      )
    }]);
  }

  const handleSubmitReviewDocument = (application) => history.push(`/application/reviewdocument/${application.applicationId}`);
  

  const doSubmitWithdraw = formData => {

    const patch = [
      {
        op: "replace",
        path: "/withdrawnReason",
        value: formData.withdrawnReason
      }
    ];

    return patchApplication(formData.id, patch).then(result => {
      clearModal();
      popToast([{
        type: "success",
        title: t("Application.Withdraw.Success.Message")
      }]);
      loadData();
      return Promise.resolve();
    });
  };

  if (!initCalled) {
    return  <Loading className="loading-component" />;
  }
  return (
    <div>
    {showAlert && (
      <div className="row">
        <Alert bsStyle="warning">
          <center>
            <strong>
              { t("AgreementDocuments.pendingSignatureErrorMessage") }
            </strong>
          </center>
        </Alert>
      </div>
    )}
    <Helmet>
      <title>Applications</title>
    </Helmet>
    <div>
      <div className={styles.states}>
        <TabContainer data-testid= "stateTest" id="application-list" onSelect={handleStateChange} defaultActiveKey={currentState}>
          <div>
            <div className={styles.tabNav + " container"}>
              <Navbar>
                <Row>
                  <Nav pullLeft className="navbar-default">
                    <NavItem key="0" eventKey="applied">
                      { t("Tab.Applications.Applications") }
                      {appliedListSummaryObject && appliedListSummaryObject.totalElements > 0 ?
                        <span className="badge bell">{appliedListSummaryObject.totalElements}</span>
                        :
                      null}
                    </NavItem>
                    <NavItem key="1" eventKey="drafts">
                      { t("Tab.Applications.DraftApplications") }
                      { draftListSummaryObject ? 
                        <span className="badge bell">{draftListSummaryObject.totalElements}</span>
                        : null
                      }
                    </NavItem>
                  </Nav>
                </Row>
              </Navbar>
            </div>
            <div>
              <TabContent>
                <TabPane key={0} eventKey="applied">
                  <div>
                    <AppliedApplicationList
                      listSummaryObject={appliedListSummaryObject}
                      onPageChanged={onPageChanged}
                      //onPageSizeChanged={this.onPageSizeChanged}
                      handleSubmitWithdraw={handleSubmitWithdraw}
                      handleSubmitReviewDocument={handleSubmitReviewDocument}
                      candidateId={candidateId}
                    />
                  </div>
                </TabPane>
                <TabPane key={1} eventKey="drafts">
                  <div>
                    <DraftApplicationList listSummaryObject={draftListSummaryObject} onPageChanged={onPageChanged} 
                    // onPageSizeChanged={this.onPageSizeChanged} 
                    />
                  </div>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </TabContainer>
      </div>
    </div>
  </div>
  );
};

export default ApplicationList;
